import React, { Component } from 'react';
import { Modal, Stack } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import { LOGO_URL } from '../../Settings';

import './menus.css';


export default class ConnectionMenu extends Component {

    constructor(props) {
        super(props);
        this.state = { show: false };
        props.app.connectionMenu = this;
    }

    componentWillUnmount() {
        this.props.app.connectionMenu = null;
    }

    show = () => {
        this.setState({ show: true });
    };


    handleClose = () => {
        this.setState({ show: false });
    };

    reconnect = () => {
        this.props.app.reconnectButton();
        this.setState({ show: false });
    }

    render() {
        return <>
            <Modal show={this.state.show}
                   onHide={this.handleClose}
                   className={'configuration-modal'}
                   dialogClassName='configuration-modal'
                   contentClassName='configuration-modal'
            >
                <Modal.Header closeButton className={'configuration-modal'}>
                    <Modal.Title>HSH Connection Lost</Modal.Title>
                </Modal.Header>

                <Modal.Body className={'configuration-modal'}>
                    <Container id={'configuration-menu-container'} className={'menu-container'}>
                        <Stack gap={3} className="button-stack">
                            <div style={{ display: 'flex', alignSelf: 'center' }}>
                                <img
                                    src={LOGO_URL}
                                    width={'150px'}
                                    height={'auto'}
                                    alt={'logo'}
                                />
                            </div>
                            <Button variant={'seed'}
                                    onClick={this.reconnect}>
                                Reconnect
                            </Button>
                        </Stack>
                    </Container>
                </Modal.Body>
            </Modal>
        </>;
    }

}
